// extracted by mini-css-extract-plugin
export var legendIndicator = "_b2-1";
export var legendRight = "_b2-0";